import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Button } from "@mui/material";
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import { CommonGridToolBarWithFilterText } from "../../../Components/Common Components/CommonComponents";
import { CurrencySymbol } from "../../../Utility/Constants";
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { AmountFormat, CheckAccessFunc, formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";


function StorePurchaseRejection() {
  const history = useHistory();
  const location = useLocation();
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [delIDs, setdelIDs] = useState([]);
  const [rejecData, setrejecData] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const EditAccess = CheckAccessFunc("Store", "Purchase", "Purchase Rejection", null, "Tab")?.editAccess



  useEffect(() => {
    getPurRejectionGet()
    if (location.states?.success_message) {
      successMessage(location.states?.success_message)
      history.push({ states: {...location?.states, success_message : "" } })
    }
  }, [])

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }
  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const getPurRejectionGet = () => {
    try {
      RestAPIService.getAll(Serviceurls.STORE_PURCHASE_REJECTION)
        .then((response) => {
          if (response.data.status === 'success') {
            setrejecData(response.data.data)
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const GetPrint = () => {
    try {
      RestAPIService.getAllPrint(Serviceurls.STORE_PURCHASE_REJECTION + `?export_type=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
    setsuccessMsg(false);
    setsuccessMsgText('');
}

  const tableView = () => {
    try {
      const gridToolBar = () => {
        return (
          <Box>
            <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} />
          </Box>
        )
      }

      rejecData?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'return_date', headerName: 'Rejection Date', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{formatDate(params?.row?.return_date) || '-'}</Box>)

        },
        {
          field: 'inward_return_number', headerName: 'PI Rejection No', flex: 0.07,
          renderCell: (params) => (params.row.inward_return_number ? params.row.inward_return_number?.length > 12 ?
            <Tooltip placement="top" title={params.row.inward_return_number}><Typography fontSize={'0.9vw'}>{params.row.inward_return_number?.slice(0, 12) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.inward_return_number || '-'}</Typography> : '-')
        },
        {
          field: 'invoice_number', headerName: 'Invoice No', flex: 0.07,
          renderCell: (params) => (params.row.invoice_number ? params.row.invoice_number?.length > 12 ?
            <Tooltip placement="top" title={params.row.invoice_number}><Typography fontSize={'0.9vw'}>{params.row.invoice_number?.slice(0, 12) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.invoice_number || '-'}</Typography> : '-')

        },
        {
          field: 'vendor_name', headerName: 'Vendor Name', flex: 0.07,
          renderCell: (params) => (params.row.vendor_name ? params.row.vendor_name?.length > 12 ?
            <Tooltip placement="top" title={params.row.vendor_name}><Typography fontSize={'0.9vw'}>{params.row.vendor_name?.slice(0, 12) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.vendor_name || '-'}</Typography> : '-')

        },
        {
          field: 'total_returned_quantity', headerName: 'Rejection Qty', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.total_returned_quantity || '-'}</Box>)

        },
        {
          field: 'net_amount', headerName: `Rejection Amount (${CurrencySymbol})`, flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{AmountFormat(params?.row?.net_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)

        },
        {
          field: 'taxable_amount', headerName: `Taxable Amount (${CurrencySymbol})`, flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{AmountFormat(params?.row?.taxable_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)

        },
        {
          field: 'gst', headerName: `GST (${CurrencySymbol})`, flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{AmountFormat((params?.row?.sgst_amount ? (params?.row?.sgst_amount * 2) : 0) || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)

        },
        {
          field: 'cgst_amount', headerName: `CGST (${CurrencySymbol})`, flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{AmountFormat((params?.row?.sgst_amount ? (params?.row?.sgst_amount) : 0) || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)

        },
        {
          field: 'sgst_amount', headerName: `SGST (${CurrencySymbol})`, flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{AmountFormat((params?.row?.sgst_amount ? (params?.row?.sgst_amount) : 0) || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)

        },
        {
          field: 'action', headerName: 'Action', flex: 0.07,
          renderCell: (params) => (
            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
              <Tooltip title={"View Product"} placement="top" arrow>
                <IconButton emed_tid={'st_view_' + params?.id} className='eMed_usrconf_btn' onClick={() => { history.push({ pathname: "/StorePurchase/PurchaseRejection/Add", states: { purchase_rejection_data: params?.row } }) }}>
                  <img src={ImagePaths.LabViewButton.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                </IconButton>
              </Tooltip>
            </Box>
          )

        },
      ];
      return (
        <Box sx={{ height: '70vh', marginTop: '.5vw', backgroundColor: 'white' }}>
          <DataGrid
            rows={rejecData}
            columns={columns}
            getRowId={(row) => row['sno']}
            page={page}
            pageSize={pageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: gridToolBar,
              NoRowsOverlay: () => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  {'No Records To Be Shown'}
                </Box>
              )
            }}
            onPageChange={(newPage) => { setpage(newPage) }}
            onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            density='standard'
            disableSelectionOnClick
            loading={isloader}
          />
        </Box>
      )
    } catch (e) {

    }
  }

  return (
    <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      <Box display={'flex'} justifyContent={'flex-end'} flexDirection={'row'} alignItems={'center'}>
        <Button disabled={!EditAccess} size="small" variant="contained" sx={{ textTransform: 'capitalize' }} onClick={() => { history.push({ pathname: "/StorePurchase/PurchaseRejection/Add" }) }}>Purchase Rejection</Button>
        <Tooltip title={'Print'} placement="top">
          <IconButton onClick={() => { GetPrint() }}          >
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.LabPrintIcon.default} alt='filter' />
          </IconButton>
        </Tooltip>
      </Box>
      <Box>
        {tableView()}
      </Box>
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
    </Box>
  );
};

export default StorePurchaseRejection;

